export default function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.loader)+' '+(props.styles.active)+'" data-hook="loader" ></div>';return out;
}


//////////////////
// WEBPACK FOOTER
// ./default-modules/ui/loader/templates/loader.dot
// module id = 159
// module chunks = 0 1 2 3 4